import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitSelfEmploymentCreations } from '../../api/self-employment/submit-self-employments';

export const useSubmitSelfEmploymentCreations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitSelfEmploymentCreations,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey:
          queryKeyStore.companyCreation.selfEmploymentCreations?.queryKey,
      });
    },
  });
};
